import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, Facet, FacetValue, SearchCriteria, FacetSearchCriteria, FacetRenderMode } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';


// Error when invalid control is dirty, touched, or submitted.
// see https://v5.material.angular.io/components/input/overview

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'admin-app',
  templateUrl: './admin-app.component.html',
  styleUrls: ['./admin-app.component.css']
})


export class AdminAppComponent implements OnInit {

  constructor(private facetedSearchAppService: FacetedSearchAppService) {
  }

  @Output()
  onConfigChange = new EventEmitter<AppConfig>();

  appConfig: AppConfig;

  appTitle = new FormControl('', [Validators.required]);

  getErrorMessage() {
    return this.appTitle.hasError('required') ? 'You must enter a title.' : "";
  }

  onConfigChanged(e: any) {
    if (!this.appTitle.hasError('required')) {
      this.facetedSearchAppService.updateAppConfig(this.appConfig);
      this.onConfigChange.emit(this.appConfig);
    }
    else {
      this.facetedSearchAppService.getAppConfig().then(x => {
        this.appConfig = x;
      });
    }
  }

  ngOnInit(): void {
    this.facetedSearchAppService.getAppConfig().then(x => {
      this.appConfig = x;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/admin-app/admin-app.component.ts